var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.fullscreenVisible)?_c('div',{class:_vm.classes},[_c('div',{class:_vm.mainClasses},[_c('span',{class:_vm.dotClasses}),_c('div',{class:_vm.textClasses},[_vm._t("default")],2)])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }